import { ProcedureSchema } from "@redotech/redo-procedures-common/markdown-flow/index";
import * as z from "zod";

export const getProcedure = {
  name: "getProcedure" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ procedure: ProcedureSchema.nullable() }),
};
